// @flow
import React from "react";
import LazyLoad from "react-lazyload";
import _ from "lodash";
import Highlighter from "react-highlight-words";
import Helper from "../../../helper/Helper";
import CONFIG from "../../../config";
import I18n from "../../../i18n/I18n";
import { Badge } from "../";
import DealBadge from "../../../images/common/onDeal.svg";
import styles from "./ProductNameBox.scss";

const ProductNameBox = props => {
  const { data, hideBadge, searchString } = props;

  const placeholder = (
    <img
      src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
      alt="default"
    />
  );
  return (
    <div className={styles.nameWrapper}>
      <div className={styles.itemImg}>
        {data.on_deal && data.on_deal !== "0" ? (
          <div className={styles.dealCtr}>
            <img src={DealBadge} alt="deal" className={styles.dealImg} />
          </div>
        ) : (
          ""
        )}
        {!data.imagekey && !data.image_key ? (
          placeholder
        ) : (
          <img
            src={Helper.getTransformationUrl(data.imagekey || data.image_key)}
            alt="product"
          />
        )}
      </div>
      <div className={styles.desc}>
        <div className={styles.name}>
          {data.title || data.itemName ? (
            <Highlighter
              highlightClassName={styles.highlight}
              searchWords={[searchString]}
              autoEscape={true}
              textToHighlight={data.title || data.itemName}
            />
          ) : (
            ""
          )}
        </div>
        <div className={styles.attributes}>
          <span className={styles.eachAttr}>
            <a>{data.brand}</a>
          </span>
          <span>
            {data.variant ? (
              <span className={styles.eachAttr}>
                {I18n.getHtml("order-details.variant", {
                  variant: data.variant
                })}
              </span>
            ) : (
              ""
            )}
          </span>
          <span>
            {data.model ? (
              <span className={styles.eachAttr}>
                {I18n.getHtml("order-details.model", {
                  model: data.model
                })}
              </span>
            ) : (
              ""
            )}
          </span>
          {data.attributes && !_.isEmpty(JSON.parse(data.attributes)) ? (
            <span className={styles.eachAttr}>
              {JSON.parse(data.attributes).colour_family ? (
                <span>
                  {I18n.getHtml("order-details.color", {
                    color: JSON.parse(data.attributes).colour_family
                  })}
                </span>
              ) : (
                ""
              )}
            </span>
          ) : (
            ""
          )}
        </div>
        {!hideBadge ? (
          <div className={styles.badge}>
            <Badge sellerB2B={!data.is_fbn} />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ProductNameBox;



// WEBPACK FOOTER //
// ./src/components/common/productNameBox/ProductNameBox.js